import Vue from 'vue'
import Plugin from './plugin'

var TravelService = function () {
  this.source = null
}

TravelService.prototype.fetchTravelMain = function () {
  return new Promise((resolve, reject) => {
    Vue.axios.get('/m/order/travel/travelMain/json', { showSpinner: false })
      .then(response => {
        resolve({
          bigBanners: response.data.content.bigBanner,
          ezFree: response.data.content.ezFree,
          hotTopics: response.data.content.hotTopics,
          promos: response.data.content.promos,
          travelGoods: response.data.content.travelGoods,
          travelCitys: response.data.content.travelCitys,
          others: response.data.content.others
        })
      })
      .catch(error => {
        reject(error)
      })
  })
}

TravelService.prototype.fetchDepartureCities = function (query) {
  return new Promise((resolve, reject) => {
    Vue.axios.get('/m/order/travel/travelMain/searchBox/departureCities')
      .then(response => {
        resolve(response)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
  })
}

TravelService.prototype.fetchArriveAll = function (query) {
  return new Promise((resolve, reject) => {
    Vue.axios.get('/m/order/travel/travelMain/searchBox/arriveAll'
    ).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
}

TravelService.prototype.suggest = function (keyWord) {
  let url = '/m/order/travel/travelMain/searchBox/suggest'
  return new Promise((resolve, reject) => {
    Vue.axios
      .post(url, { keyWord }, { notDisplaySpinner: true })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

Vue.use(Plugin, new TravelService())



// WEBPACK FOOTER //
// ./src/services/travel-service/index.js